import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function TextInput(props) {
	const { name, code, placeholder, value, readonly, onChange } = props;

	return (
		readonly ?
			<span className="form-control form-control-sm ml-1 mr-1 prn-readonly-text">{value}</span> :
			<input
				type="text"
				className="form-control form-control-sm ml-1 mr-1"
				placeholder={placeholder}
				defaultValue={value}
				onBlur={onChange.bind(null, code, name)}
			/>
	)
}

function DiagnosticStatement(props) {
	const { schema, formData, readonly, onChange } = props;
	const { title } = schema;

	let {
		S1$G1: clientName,
		F227: diagnosticCodes,
	} = useSelector(state => state.form.formData);

	let [statements, setStatements] = useState(formData || []);

	let { F1: firstName, F2: lastName } = clientName;

	let defaultValue = {
		code: "",
		timePeriod: "",
		reason: "",
		reason2: "",
	}

	useEffect(() => {
		let items = [];

		if (!readonly) {
			_.forEach(diagnosticCodes, (code) => {
				let i = _.findIndex(statements, (stmt) => {
					return stmt.code === code
				})

				if (i === -1) {
					items.push({
						...defaultValue,
						code
					});
				} else {
					items.push(statements[i])
				}
			});

			setStatements(items);
		}
	}, [JSON.stringify(diagnosticCodes), JSON.stringify(formData)]);

	useEffect(() => {
		onChange(statements);
	}, [statements]);

	function handleChange(code, field, e) {
		let newStatements = [...statements];

		let index = _.findIndex(newStatements, (stmt) => {
			return stmt.code === code
		})

		if (index !== -1) {
			newStatements[index] = {
				...newStatements[index],
				[field]: e.target.value
			}
		}

		setStatements(newStatements);
	}

	return (
		<React.Fragment>
			{!_.isEmpty(statements) && <label>{title}</label>}

			{statements.map((stmt, i) => {
				return (
					<React.Fragment key={i}>
						<div className="form-inline">
							<p className="mb-0 diagnostic-statement-info">I believe <span className="font-weight-bold">{`${firstName} ${lastName}`}</span> to be experiencing&nbsp;
              <span className="font-weight-bold">{stmt.code}</span> for at least the past
              <TextInput
									name="timePeriod"
									code={stmt.code}
									placeholder="time period"
									onChange={handleChange}
									value={stmt.timePeriod}
									readonly={readonly}
								/>as evidenced by
              <TextInput
									name="reason"
									code={stmt.code}
									placeholder="list of reasons"
									onChange={handleChange}
									value={stmt.reason}
									readonly={readonly}
								/>causing impairment in client’s
								<TextInput
									name="reason2"
									code={stmt.code}
									placeholder="type here..."
									onChange={handleChange}
									value={stmt.reason2}
									readonly={readonly}
								/>
							</p>
						</div>
						<hr className="mt-4 mb-4" />
					</React.Fragment>
				)
			})}
		</React.Fragment>
	)
}

export default DiagnosticStatement;